// import React from 'react';
// import { Link } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './AboutUs.css';

// import aboutUsImage from '../assets/img/slider_img/about.jpg';

// const AboutUs = () => {
//     return (
//         <section className="about-us container-fluid">
//             <div className="row align-items-center">
//                 {/* Left Side - Content */}
//                 <div className="col-lg-6 text-center text-lg-start p-5">
//                     <h2 className="about-heading">Meet the Visionary Behind Breast Infrared Imaging</h2>
//                     <p className="about-text">
//                         <strong>Dr. R.R. Joshi</strong>, the founder of MIDC Breast Infrared Imaging, is a pioneer in the field of medical Infrared in India. With a strong medical background and a passion for preventive healthcare, <strong>Dr. Joshi</strong> introduced thermal imaging as a non-invasive diagnostic tool as early as 2005. Under his leadership, MIDC became the first and only institution in India to apply Infrared with clinical precision and ethical standards.
//                         <br /><br />
//                         Driven by innovation and compassion, <strong>Dr. Joshi</strong>’s mission is to provide early detection solutions for breast health and other physiological disorders through safe, radiation-free thermal scanning. His work is recognized by leading medical organizations and practitioners across the country.
//                     </p>
//                     {/* <button className="btn gradient-btn">Learn More ➜</button> */}
//                     <Link to="/why" className="btn gradient-btn">Learn More ➜</Link>

//                 </div>

//                 {/* Right Side - Image */}
//                 <div className="col-lg-6 p-0 d-flex justify-content-center">
//                     <img 
//                         alt="Founder of MIDC" 
//                         className="img-fluid" 
//                         src={aboutUsImage}
//                         style={{
//                             width: '80%',
//                             height: '60vh',
//                             objectFit: 'cover'
//                         }} 
//                     />
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default AboutUs;

import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AboutUs.css';

import aboutUsImage from '../assets/img/slider_img/about.jpg';

const AboutUs = () => {
    return (
        <section className="about-us container-fluid">
            <div className="row align-items-center">
                {/* Left Side - Content */}
                <div className="col-lg-6 text-center text-lg-start p-5">
                    <h2 className="about-heading">Meet the Visionary Behind Breast Infrared Imaging</h2>
                    {/* Thermal Image Gradient Line */}
                    <div className="thermal-line"></div>
                    <p className="about-text">
                        <strong>Dr. R.R. Joshi</strong>, the founder of MIDC Breast Infrared Imaging, is a pioneer in the field of medical Infrared in India. With a strong medical background and a passion for preventive healthcare, <strong>Dr. Joshi</strong> introduced thermal imaging as a non-invasive diagnostic tool as early as 2005. Under his leadership, MIDC became the first and only institution in India to apply Infrared with clinical precision and ethical standards.
                        <br /><br />
                        Driven by innovation and compassion, <strong>Dr. Joshi</strong>’s mission is to provide early detection solutions for breast health and other physiological disorders through safe, radiation-free thermal scanning. His work is recognized by leading medical organizations and practitioners across the country.
                    </p>
                    <Link to="/why" className="btn gradient-btn">Learn More ➜</Link>
                </div>

                {/* Right Side - Image */}
                <div className="col-lg-6 p-0 d-flex justify-content-center">
                    <img 
                        alt="Founder of MIDC" 
                        className="img-fluid" 
                        src={aboutUsImage}
                        style={{
                            width: '80%',
                            height: '60vh',
                            objectFit: 'cover'
                        }} 
                    />
                </div>
            </div>
        </section>
    );
};

export default AboutUs;
